import { type ComponentProps, type ReactNode, useMemo } from "react"

import { Button, type ButtonProps, Popup } from "semantic-ui-react"
import type { CSSProperties } from "styled-components"

type TooltipButtonProps = ButtonProps & {
  tooltip?: ReactNode
  tooltipProps?: ComponentProps<typeof Popup>
  wrapperStyle?: CSSProperties
}

const TooltipButton = ({ tooltip, tooltipProps = {}, wrapperStyle = {}, ...props }: TooltipButtonProps) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: Will need to remedy spread props
  const button = useMemo(() => <Button {...props} />, [props])
  if (!tooltip) {
    return button
  }
  return (
    <Popup
      {...tooltipProps}
      content={tooltip}
      trigger={<div style={{ display: "inline-block", ...wrapperStyle }}>{button}</div>}
    />
  )
}

export default TooltipButton
